import { Suspense } from 'react';
import { Card } from 'react-bootstrap';

import { DOILoadReference } from './reference/DOILoadReference';
import { DOIReferenceURL } from './reference/DOIReferenceURL';
import { type DOI } from './utils/doi';
import { Loading } from './utils/Loading';

export function DOIRelated({ doi }: { doi: DOI }) {
  if (
    doi.relatedDOI.length === 0 &&
    doi.referenceURLs.length === 0 &&
    doi.describedByDOIs.length === 0 &&
    !doi.isNewVersionOfDOI &&
    !doi.isPreviousVersionOfDOI
  ) {
    return null;
  }
  return (
    <Card>
      <Card.Header className="p-2">Related Resources</Card.Header>
      <Card.Body className="p-0">
        {doi.relatedDOI.map((relatedDoi, index, self) => (
          <div
            key={relatedDoi}
            className={`p-2 ${
              index === self.length - 1 ? '' : 'border-bottom border-black'
            }`}
          >
            <Suspense fallback={<Loading />}>
              <DOILoadReference doi={relatedDoi} />
            </Suspense>
          </div>
        ))}
        <DOIReferenceURL doi={doi} />
        {doi.describedByDOIs.length > 0 && (
          <div className="p-2">
            Described by: {doi.describedByDOIs.join(', ')}
          </div>
        )}
        {doi.isNewVersionOfDOI && (
          <div className="p-2">Is new version of: {doi.isNewVersionOfDOI}</div>
        )}
        {doi.isPreviousVersionOfDOI && (
          <div className="p-2">
            Is previous version of: {doi.isPreviousVersionOfDOI}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
